import React from 'react';
import { CookiesProvider } from 'react-cookie';
import 'tslib';
import '@invitae/location-lite-core';
import './aspects/domain/context.esm.js';
import { LocationLiteDomainProvider } from './aspects/domain/provider.esm.js';
import { DEFAULT_POLLING_INTERVAL, DEFAULT_MAX_POLLING_TIME } from './aspects/polling/constants.esm.js';
import './node_modules/cookie/index.esm.js';
import { LocationLitePollingProvider } from './aspects/polling/provider.esm.js';

/**
 * Primary LocationLite provider for an application
 *
 * Orchestrates and standardizes data flow across sub-contexts. Users generally will not
 * need to directly interface with these inner contexts. Provide a URL or hostname to an API
 * that is running the LocationLite Middleware to sync location cookie across front-end and back-end.
 */
var LocationLiteProvider = function (_a) {
    var _b;
    var children = _a.children, apiGateway = _a.apiGateway, _c = _a.domainFallback, domainFallback = _c === void 0 ? (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.hostname : _c, _d = _a.includeCookiesProvider, includeCookiesProvider = _d === void 0 ? true : _d, _e = _a.pollingInterval, pollingInterval = _e === void 0 ? DEFAULT_POLLING_INTERVAL : _e, _f = _a.maxPollingTime, maxPollingTime = _f === void 0 ? DEFAULT_MAX_POLLING_TIME : _f;
    return includeCookiesProvider ? (React.createElement(CookiesProvider, null,
        React.createElement(LocationLiteDomainProvider, { apiGateway: apiGateway, domainFallback: domainFallback },
            React.createElement(LocationLitePollingProvider, { maxPollingTime: maxPollingTime, pollingInterval: pollingInterval }, children)))) : (React.createElement(LocationLiteDomainProvider, { apiGateway: apiGateway, domainFallback: domainFallback },
        React.createElement(LocationLitePollingProvider, { maxPollingTime: maxPollingTime, pollingInterval: pollingInterval }, children)));
};

export { LocationLiteProvider };
//# sourceMappingURL=provider.esm.js.map
